import { call, put, all, takeEvery } from 'redux-saga/effects'

import {
  GET_SELF_ACCOUNTS,
  getSelfAccountsSuccess,
  getSelfAccountsFailure,
  GET_SELF_ACCOUNT,
  getSelfAccountSuccess,
  getSelfAccountFailure,
  CREATE_SELF_ACCOUNT,
  createSelfAccountSuccess,
  createSelfAccountFailure,
  UPDATE_SELF_ACCOUNT,
  updateSelfAccountSuccess,
  updateSelfAccountFailure,
  GET_PARTNER_SELF_ACCOUNT,
  getPartnerSelfAccountSuccess,
  getPartnerSelfAccountFailure
} from '../actions/selfAccounts'
import {
  getSelfAccountsService,
  getSelfAccountService,
  createSelfAccountService,
  updateSelfAccountService
} from '../services/selfAccounts'
import { createCurrentUserSelfAccount, setSelectedSelfAccount, updateCurrentUserSelfAccount } from '../actions/app'

function* selfAccountsWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_SELF_ACCOUNTS, getSelfAccountsWorker),
    takeEvery(GET_SELF_ACCOUNT, getSelfAccountWorker),
    takeEvery(GET_PARTNER_SELF_ACCOUNT, getPartnerSelfAccountWorker),
    takeEvery(CREATE_SELF_ACCOUNT, createSelfAccountWorker),
    takeEvery(UPDATE_SELF_ACCOUNT, updateSelfAccountWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getSelfAccountsWorker({ params }) {
  try {
    const response = yield call(getSelfAccountsService, params)
    yield put(getSelfAccountsSuccess(response))
  } catch (e) {
    yield put(getSelfAccountsFailure(e))
  }
}

function* getSelfAccountWorker({ id, showErrorToast }) {
  try {
    const response = yield call(getSelfAccountService, id, showErrorToast)
    yield put(getSelfAccountSuccess(response))
  } catch (error) {
    yield put(getSelfAccountFailure(error))
  }
}

function* getPartnerSelfAccountWorker({ id }) {
  try {
    const response = yield call(getSelfAccountService, id)
    yield put(getPartnerSelfAccountSuccess(response))
  } catch (error) {
    yield put(getPartnerSelfAccountFailure(error))
  }
}

function* createSelfAccountWorker({ selfAccountData, selectSelfAccountOnSuccess }) {
  try {
    const response = yield call(createSelfAccountService, selfAccountData)
    yield put(createSelfAccountSuccess(response))

    // also update current user profile accounts
    yield put(createCurrentUserSelfAccount(response))

    // we need to set selected self account in case like first login flow
    if (selectSelfAccountOnSuccess) {
      yield put(setSelectedSelfAccount(response.id))
    }
  } catch (e) {
    yield put(createSelfAccountFailure(e))
  }
}

function* updateSelfAccountWorker({ id, selfAccountData }) {
  try {
    const response = yield call(updateSelfAccountService, id, selfAccountData)
    yield put(updateSelfAccountSuccess(response))

    // also update current user profile accounts
    yield put(updateCurrentUserSelfAccount(response))
  } catch (e) {
    yield put(updateSelfAccountFailure(e))
  }
}

export default selfAccountsWatcher
